<template>
    <div class="exams">
        <div class="row">
            <div class="col-12 col-md-8 digital-studies-wrapper">
                <div class="apprentice-simple-card digital-studies">
                    <div class="component-title">
                        <h5 class="title">{{$t('exams.explanation_videos')}}</h5>
                    </div>
                    <div class="description">{{$t('exams.watch_here_explanation_videos_about_all_subjects_for_upper_secondary_student')}}</div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-4 digital-study" v-for="education_level in educationLevelsIn"
                             :key="education_level.id">
                            <div class="apprentice-simple-card digital-studies-card education-level-card">
                                <div class="icon">
                                    <i class="btn btn-primary-icon-only fad "
                                       :class="getEducationIcon(education_level)"></i>
                                </div>
                                <div class="content">
                                    <h5 class="title">{{ education_level.name }}</h5>
                                </div>
                                <a href="" class="clickable" @click="redirectVideo(education_level.id, $event)"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 pracical-exams-wrapper">
                <div class="apprentice-simple-card pracical-exams">
                    <div class="component-title">
                        <h5 class="title">{{$t('exams.practice_exams')}}</h5>
                    </div>

                    <div class="apprentice-simple-card digital-studies-card">
                        <div class="icon">
                            <i class="btn btn-primary-icon-only fad fa-user-graduate"></i>
                        </div>
                        <div class="content">
                            <h5 class="title">{{$t('exams.lecture_for_tests_and_exams')}}</h5>
                            <div class="description">
                                {{$t('exams.find_all_exams_from_recent_years_here_to_practice')}}
                            </div>
                        </div>
                        <a href="" class="clickable" @click="redirectPracticalExams($event)"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-exams-index-component",
    props: [
        'educationLevelsIn'
    ],
    methods: {
        redirectVideo(id, ev) {
            ev.preventDefault();
            window.location.href = this.routes.digistudiesVideo(id);
        },

        redirectPracticalExams(ev) {
            ev.preventDefault();
            window.location.href = this.routes.practiceExams();
        },

        getEducationIcon(educationlevel) {
            switch (educationlevel.name.toLowerCase()) {
                case 'vmbo':
                    return 'fa-ruler-triangle';
                case 'havo':
                    return 'fa-users-class';
                case 'vwo':
                    return 'fa-globe-stand';
            }
        },
    }
}
</script>

<style scoped lang="scss">
.digital-studies-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.digital-studies {
    .description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .digital-study {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.description {
    color: $text-muted-color;
}

.digital-studies-card {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;

    .icon {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 6rem;
        }
    }

    &.education-level-card {
        .content {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    ;
    }

    .content {
        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    &:hover {
        box-shadow: 0 3px 21px 0 rgb(0 0 0 / 10%), 0 1px 8px 0 rgb(0 0 0 / 5%);
    }
}

.pracical-exams {
    height: 100%;

    .digital-studies-card {
        height: initial;
    }
}

@media(min-width: map-get($grid-breakpoints, 'xl')) {
    .digital-studies-wrapper {
        margin-bottom: 0;
    }

    .digital-studies {
        .digital-study {
            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }
}
</style>
